import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";

import {
  FILE_LIST,
  CLIENTS,
  getAuthToken,
  getUserRoles,
} from "../helpers/constants";

interface AuthProps {
  allowedRoles: any;
}

const Auth: React.FC<AuthProps> = ({ allowedRoles }) => {
  const location = useLocation();
  let hasAuthToken = getAuthToken();
  let roles = getUserRoles();

  let route = allowedRoles.find((role: any) => roles.includes(role))
    ? `/${CLIENTS}`
    : `/${FILE_LIST}`;

  return hasAuthToken ? (
    <Navigate to={route} state={{ from: location }} replace />
  ) : (
    <Outlet />
  );
};

export default Auth;
